import type CalendarSurfaceStore from '../schema/CalendarSurfaceStore';
import { mutatorAction } from 'satcheljs';

export const removeCalendarItems = mutatorAction(
    'removeCalendarItems',
    (deletedItemIds: string[], store: CalendarSurfaceStore) => {
        if (deletedItemIds) {
            let itemsDeletedIndexes = [];
            store.calendarItems.forEach((item, index) => {
                if (deletedItemIds.includes(item.ItemId.Id)) {
                    itemsDeletedIndexes.push(index);
                }
            });
            itemsDeletedIndexes.forEach((calendarItemIndex: number, deletedItemCount: number) => {
                store.calendarItems.splice(calendarItemIndex - deletedItemCount, 1);
            });
        }
    }
);
